export const environment = {
  firebase: {
    apiKey: "AIzaSyA20L5lV9SvRD9nE_OBF5wlfpiewoPCWnY",
    authDomain: "recogera-prod.firebaseapp.com",
    databaseURL: "https://recogera-prod-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "recogera-prod",
    storageBucket: "recogera-prod.firebasestorage.app",
    messagingSenderId: "1063165209422",
    appId: "1:1063165209422:web:1837f210ab86e711b44c1f",
    measurementId: "G-HFCXW9Q1HB"
  },
  cfBase: 'https://europe-west1-recogera-prod.cloudfunctions.net/',
  production: true,
  version: '0.5.0',
  buildNumber: '',
  id: 'prod',
  region: 'europe-west1',
  mobileHostingURL: 'https://student.recogera.com',
  features: { teacherRedesign: true },
};
